export const navTokens = {
  primary: "#F5A623",
  primaryHover: "#E49B1F",
  border: "#E5E7EB",
  focusRing: "rgba(245, 166, 35, 0.3)",
  text: "#111827",
  textMuted: "#6B7280",
  textSubtle: "#9CA3AF",
  bg: "#FFFFFF",
  bgMuted: "#F3F4F6",
  menuBg: "#FFFFFF",
  menuHover: "#F9FAFB",
  menuSelectedBg: "#FFF7ED",
  menuSelectedText: "#C2410C",
  shadow:
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  softShadow: "0 6px 18px rgba(15, 23, 42, 0.08)",
} as const;
